module.exports = __webpack_public_path__ + "static/img/gift-13.79d4057.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/winter-camp/assets/gift-13.png
// module id = 357
// module chunks = 140